import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import CU from "@/utils/c-u";

export class ListTextPanel extends Phaser.GameObjects.Container {

    constructor(scene: Phaser.Scene, txt: string, height: number) {
        super(scene);

        this.scene = scene;
        this.height = height;

        let descText = TextUtils.addTextAdvanced(scene, txt, 0, height / 2 + 4,
            '#e2e2e2', 13, 'normal', 480, 'center', 2, Fonts.MYRIADPRO_REGULAR);

        this.add(descText);
    }

}
